<template>
    <div>

        <g-card :temCabecalho="false">
      <div class="container-form">
        <img class="ilustracao-sem-acesso" :src="require(`@/assets/imgs/Sem_Acesso.svg`)" />

        <div class="titulo-geral alinhar">
            VOCÊ NÃO TEM PERMISSÃO PARA ACESSAR ESTA ÁREA
        </div>
        <div class="titulo-grupo-formulario alinhar">
            Por favor, entre em contato com o suporte se precisar de ajuda.
        </div>

          <div class="alinha-button-fluxo">
            <div class="button-fluxo">
              <g-button
              tipo="amarelo" 
              negritoTexto 
              altura="45px"
              largura="100%"
              @click="this.$router.push('/dashboard')"
              >
              VOLTAR PARA O INICIO
              </g-button>
            </div>
          </div>
      </div>
    </g-card>

        
    </div>
</template>

<script>
import SemAcesso from './SemAcesso.js' 
export default SemAcesso
</script>

<style scoped>
.alinhar{
    text-align: center;
}

.titulo-geral {
  color: #4f2c19;
  font-weight: bold;
  font-family: "MontSerrat";
}

.ilustracao-sem-acesso{
    margin-top: 5%;
}

@media (min-width:310px) {
.titulo-geral {
  font-size: 18px;
} 

.ilustracao-sem-acesso{
    width: 100%;
}
    
}

@media (min-width:368px) {

}

@media (min-width:600px) {
.titulo-geral {
  font-size: 20px;
}

.ilustracao-sem-acesso{
    width: 60%;
}
}

@media (min-width:801px) {
.titulo-geral {
  font-size: 22px;
} 
.ilustracao-sem-acesso{
    width: 50%;
}

}

@media (min-width:1025px) { 
.ilustracao-sem-acesso{
    width: 40%;
}
}

@media (min-width:1281px) { 
    
}


</style>
